// wechatSDK.js
import wx from 'weixin-js-sdk'
import axios from 'axios';
import Vue from 'vue'
// 全局变量，保存已配置好的微信 JS-SDK 对象
let wechatSDKInstance = null;

// 通过异步请求获取签名参数
function fetchSignatureParams() {
  return new Promise((resolve, reject) => {
    // 发送请求到服务器端获取签名参数的接口
    axios.get('https://jsmap.onbotics.cn/api/map/getJsApiSignature?url=https://app.pgather.onbotics.cn')
      .then(response => {
        const { timestamp, nonceStr, signature } = response.data;
        resolve({ timestamp, nonceStr, signature });
      })
      .catch(error => {
        reject(error);
      });
  });
}

// 配置微信 JS-SDK
export function configureWechatSDK() {
  if (wechatSDKInstance) {
    console.log("already has instance")
    // 如果已经存在配置好的微信 JS-SDK 对象，直接返回 Promise 对象
    return Promise.resolve(wechatSDKInstance);
  }

  return new Promise((resolve, reject) => {

    // 调用获取签名参数的函数
    fetchSignatureParams()
      .then(signatureParams => {
        console.log(signatureParams.appId)
        console.log(signatureParams.timestamp)
        // 使用签名参数配置 wx.config
        wx.config({
          appId: "wx5b7ea8c7c51067a2",
          timestamp: signatureParams.timestamp,
          nonceStr: signatureParams.nonceStr,
          signature: signatureParams.signature,
          jsApiList: ['getLocation'],
          debug:false
        });
        console.log("wxabcdddddd")
        // wx.config 完成后调用其他微信 JS-SDK 相关方法
        wx.ready(() => {
            console.log("wxabcd")
          wechatSDKInstance = wx; // 保存配置好的微信 JS-SDK 对象到全局变量
          resolve(wechatSDKInstance);
        });
        wx.error(function(res) {
            console.log("abcderror")
            console.log(res.errMsg); // 必填，接口调用失败的错误信息
        });
      })
      .catch(error => {
        reject(error);
      });
  });
}

// 获取用户定位
export function getUserLocation(wechatSDKInstance) {
  if (!wechatSDKInstance) {
  
    // 如果微信 JS-SDK 对象未配置，则返回 Promise.reject()，表示未配置微信 JS-SDK
    return Promise.reject(new Error('Wechat SDK is not configured.'));
  }
  else{
    console.log("abcd720210222")
  return new Promise((resolve, reject) => {
    wechatSDKInstance.getLocation({
      success: function (res) {
        const { latitude, longitude } = res;
        console.log(res)
        resolve({ latitude, longitude });
      },
      fail: function (error) {
        reject(error);
      }
    });
  });

  }
}



// WEBPACK FOOTER //
// ./src/utils/wechatSDK.js